import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import TextArea from 'react-autosize-textarea';
import outline from 'helpers/outline';
import {transition} from 'helpers/css';

export type InputTitleProps
  = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Container = styled(TextArea)`
  width: 100%;
  border-radius: 5px;
  box-sizing: border-box;
  padding: 10px 14px;
  resize: none;
  background-color: ${({theme}) => `
    ${theme.variables.accentBackgroundColor}
  `};

  font-weight: 600;
  line-height: 22px;

  &, &::placeholder {
    ${transition()};
  }
  
  &::placeholder {
    color: ${({theme}) => `
      ${transparentize(.6, theme.variables.color)};
    `};
  }
  
  &:focus {
    ${outline(0, 1)};
    &::placeholder {
      color: ${({theme}) => `
        ${transparentize(.9, theme.variables.color)};
      `};
    }
  }
`;

/**
 * The input title component
 * @param {InputTitleProps} props
 * @return {React.ReactElement<InputTitleProps>}
 * @constructor
 */
export default function InputTitle(
    props: InputTitleProps,
): React.ReactElement<InputTitleProps> {
  return <Container {...props} />;
}
